export default "__VITE_ASSET__0eeQcwTx__"